/**
 * Size-aware product add-ons.
 *
 * Watches the tree's height option and offers the matching stand and lights.
 * Markup and the height -> accessory map: snippets/product-addons.liquid.
 *
 * On Add to Cart the tree and any ticked add-ons go up in ONE /cart/add.js
 * call, so the drawer opens once with everything in it. The theme's own
 * product form handler is bypassed for that submit and its post-add flow
 * (notification, drawer refresh) is invoked afterwards so nothing else changes.
 */
(function () {
  'use strict';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function money(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try { return window.Shopify.formatMoney(cents, window.MinimogSettings.money_format); } catch (e) { /* fall through */ }
    }
    return '£' + (cents / 100).toFixed(2);
  }

  function Addons(el) {
    this.el = el;
    this.productId = String(el.dataset.productId || '');
    this.heightIndex = Number(el.dataset.heightIndex || 0);
    this.fittingService = el.dataset.fittingService || '';
    this.form = document.querySelector('form[data-type="add-to-cart-form"][data-product-id="' + this.productId + '"]')
      || document.querySelector('form[data-type="add-to-cart-form"]');

    var payload = el.querySelector('[data-addon-data]');
    try {
      this.data = JSON.parse(payload.textContent);
    } catch (e) {
      // A malformed payload must not take the Add to Cart button down with it.
      console.warn('Product add-ons: could not read the accessory data.', e);
      el.hidden = true;
      return;
    }

    if (this.data.unresolved) {
      console.warn('Product add-ons: no variant found for ' + this.data.unresolved +
        '. Check the ids in snippets/product-addons.liquid.');
    }

    this.cards = {
      stand: el.querySelector('[data-addon="stand"]'),
      lights: el.querySelector('[data-addon="lights"]'),
      collection: el.querySelector('[data-addon="collection"]')
    };
    // The removal service is the only add-on that needs choices of its own.
    this.collection = { service: null, date: null };
    this.colour = this.data.lights.colours[0] ? this.data.lights.colours[0].key : null;
    this.height = null;
    this.service = null;

    this.buildSwatches();
    this.buildCollection();
    this.bind();
    this.readVariant(this.currentVariant());
  }

  /**
   * Opening state comes from Liquid rather than from a JS global - the theme
   * doesn't expose the selected variant anywhere documented, and the server
   * already knows it.
   */
  Addons.prototype.currentVariant = function () {
    var height = this.el.dataset.initialHeight || '';
    var service = this.el.dataset.initialService || '';
    if (!height) return null;
    var options = [];
    options[this.heightIndex] = height;
    return { options: options, service: service };
  };

  Addons.prototype.buildSwatches = function () {
    var self = this;
    var wrap = this.cards.lights.querySelector('[data-addon-swatches]');
    this.data.lights.colours.forEach(function (colour) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'padd__swatch';
      b.dataset.colour = colour.key;
      b.textContent = colour.label;
      b.addEventListener('click', function () {
        self.colour = colour.key;
        self.render();
      });
      wrap.appendChild(b);
    });
  };

  /**
   * Removal service and collection date. Size is derived from the tree height,
   * so only these two are asked; both are revealed only once the box is ticked.
   */
  Addons.prototype.buildCollection = function () {
    var self = this;
    var card = this.cards.collection;
    var data = this.data.collection;
    if (!card || !data || !data.available) return;

    this.collection.service = data.services[0] || null;
    this.collection.date = data.dates[0] || null;

    var services = card.querySelector('[data-collection-services]');
    data.services.forEach(function (name) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'padd__swatch';
      b.dataset.service = name;
      b.textContent = name;
      b.addEventListener('click', function () {
        self.collection.service = name;
        self.render();
      });
      services.appendChild(b);
    });

    var select = card.querySelector('[data-collection-date]');
    data.dates.forEach(function (date) {
      var o = document.createElement('option');
      o.value = date;
      o.textContent = date;
      select.appendChild(o);
    });
    select.addEventListener('change', function () {
      self.collection.date = select.value;
      self.render();
    });
  };

  Addons.prototype.collectionFor = function () {
    var data = this.data.collection;
    if (!data || !data.available || !this.height) return null;
    var size = data.sizeByHeight[this.height];
    if (!size) return null;
    var variant = data.variants[size + '|' + this.collection.service + '|' + this.collection.date];
    if (!variant) return null;
    return {
      id: variant.id,
      price: variant.price,
      available: variant.available,
      name: size + ' · ' + this.collection.service,
      image: data.image,
      size: size
    };
  };

  Addons.prototype.bind = function () {
    var self = this;

    Object.keys(this.cards).forEach(function (key) {
      if (!self.cards[key]) return;
      var toggle = self.cards[key].querySelector('[data-addon-toggle]');
      toggle.addEventListener('change', function () {
        self.cards[key].classList.toggle('is-on', toggle.checked);
        var details = self.cards[key].querySelector('[data-collection-details]');
        if (details) details.hidden = !toggle.checked;
      });
    });

    // The theme announces every variant change on this channel.
    var events = window.MinimogEvents;
    if (events && events.subscribe) {
      events.subscribe(this.productId + '__VARIANT_CHANGE', function (variant) {
        self.readVariant(variant);
      });
    }

    // Capture on document so this runs before the theme's own submit handler,
    // which is bound directly on the form and would otherwise win.
    document.addEventListener('submit', function (event) {
      if (event.target !== self.form) return;
      if (!self.selected().length) return;          // nothing extra - leave the theme alone
      event.preventDefault();
      event.stopPropagation();
      self.addAll();
    }, true);
  };

  /** Pull the height (and delivery service) out of a variant's options. */
  Addons.prototype.readVariant = function (variant) {
    if (variant && variant.options) {
      this.height = variant.options[this.heightIndex] || null;
      this.service = variant.service || variant.options.join(' / ');
    }
    this.render();
  };

  Addons.prototype.standFor = function () {
    return (this.height && this.data.stand.byHeight[this.height]) || null;
  };

  Addons.prototype.colourData = function (key) {
    var found = null;
    this.data.lights.colours.forEach(function (c) { if (c.key === key) found = c; });
    return found;
  };

  Addons.prototype.lightsFor = function (colourKey) {
    var colour = this.colourData(colourKey || this.colour);
    if (!colour || !this.height) return null;
    return colour.byHeight[this.height] || null;
  };

  /** Any height with at least one colour available. */
  Addons.prototype.anyLights = function () {
    var self = this;
    return this.data.lights.colours.some(function (c) { return Boolean(c.byHeight[self.height]); });
  };

  Addons.prototype.paint = function (card, item, matchText) {
    var pick = card.querySelector('[data-addon-pick]');
    var price = card.querySelector('[data-addon-price]');
    var thumb = card.querySelector('[data-addon-thumb]');
    var toggle = card.querySelector('[data-addon-toggle]');

    if (item && item.available) {
      toggle.disabled = false;
      toggle.value = item.id;
      card.classList.remove('is-unavailable');
      pick.innerHTML = 'Recommended for a ' + this.height + ' tree: <span class="padd__match"></span>';
      pick.querySelector('.padd__match').textContent = matchText;
      price.textContent = money(item.price);
      thumb.innerHTML = item.image ? '<img src="' + item.image + '" alt="" loading="lazy" width="46" height="46">' : '';
    } else {
      toggle.checked = false;
      toggle.disabled = true;
      card.classList.remove('is-on');
      card.classList.add('is-unavailable');
      price.textContent = '';
    }
  };

  Addons.prototype.render = function () {
    var self = this;

    // ---- stand ----
    // No mapping row for this height means the accessory doesn't apply to this
    // product at all (potted trees arrive in a pot) - hide it rather than show a
    // dead row. Mapped-but-sold-out is different, and stays visible below.
    var stand = this.standFor();
    var standCard = this.cards.stand;
    standCard.hidden = !stand;
    if (stand) this.paint(standCard, stand, stand.name);

    // ---- lights ----
    var lightsCard = this.cards.lights;
    var swatches = lightsCard.querySelector('[data-addon-swatches]');
    var note = lightsCard.querySelector('[data-addon-note]');
    var any = this.anyLights();

    swatches.hidden = !any;
    [].forEach.call(swatches.children, function (b) {
      var has = Boolean(self.lightsFor(b.dataset.colour));
      b.disabled = !has;
      b.setAttribute('aria-pressed', String(has && b.dataset.colour === self.colour));
      b.title = has ? '' : b.textContent + ' has no set for a ' + self.height + ' tree';
    });

    var chosen = this.lightsFor();
    lightsCard.hidden = !any;
    if (!any) {
      this.paint(lightsCard, null);
    } else if (!chosen) {
      this.paint(lightsCard, null);
      var alt = this.data.lights.colours.filter(function (c) { return c.byHeight[self.height]; })[0];
      lightsCard.querySelector('[data-addon-pick]').textContent =
        this.colourData(this.colour).label + ' has no set this size' + (alt ? ' — try ' + alt.label + '.' : '.');
    } else {
      this.paint(lightsCard, chosen, this.colourData(this.colour).label + ' · ' + chosen.name);
    }

    // ---- January removal ----
    var collectionCard = this.cards.collection;
    if (collectionCard) {
      var collection = this.collectionFor();
      collectionCard.hidden = !collection;
      if (collection) {
        this.paint(collectionCard, collection, collection.name);
        [].forEach.call(collectionCard.querySelectorAll('[data-collection-services] .padd__swatch'), function (b) {
          b.setAttribute('aria-pressed', String(b.dataset.service === self.collection.service));
        });
        collectionCard.querySelector('[data-collection-date]').value = this.collection.date;
      }
    }

    this.el.hidden = standCard.hidden && lightsCard.hidden &&
      (!collectionCard || collectionCard.hidden);

    // The fitting service supplies labour, not lights - say so before they ask.
    var fitting = this.fittingService && this.service && this.service.indexOf(this.fittingService) > -1;
    note.hidden = !(fitting && any);
    if (!note.hidden) {
      note.textContent = 'Your delivery service fits lights but doesn’t include them. Add a set here if you need one.';
    }
  };

  /** Ticked, available add-ons as /cart/add.js line items. */
  Addons.prototype.selected = function () {
    var items = [];
    Object.keys(this.cards).forEach(function (key) {
      if (!this.cards[key]) return;
      var toggle = this.cards[key].querySelector('[data-addon-toggle]');
      if (toggle.checked && !toggle.disabled && toggle.value) {
        items.push({ id: Number(toggle.value), quantity: 1 });
      }
    }, this);
    return items;
  };

  Addons.prototype.addAll = function () {
    var self = this;
    var idField = this.form.querySelector('[name="id"]');
    var qtyField = this.form.querySelector('[name="quantity"]');
    var treeId = Number(idField && (idField.value || idField.dataset.selectedVariant));
    if (!treeId) return;

    var items = [{ id: treeId, quantity: Number(qtyField && qtyField.value) || 1 }].concat(this.selected());
    var button = this.form.querySelector('[name="add"], [type="submit"]');
    if (button) button.classList.add('sf-spinner-loading');

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        return response.json().then(function (body) {
          if (!response.ok) throw body;
          return body;
        });
      })
      .then(function (body) {
        var first = (body.items && body.items[0]) || body;
        // Hand back to the theme so the drawer, count and toast behave as usual.
        if (window.MinimogEvents && window.MinimogEvents.emit) {
          window.MinimogEvents.emit('ON_ITEM_ADDED', first);
        }
        if (window.Shopify && typeof window.Shopify.onItemAdded === 'function') {
          window.Shopify.onItemAdded(first);
        }
        Object.keys(self.cards).forEach(function (key) {
          if (!self.cards[key]) return;
          var toggle = self.cards[key].querySelector('[data-addon-toggle]');
          toggle.checked = false;
          self.cards[key].classList.remove('is-on');
          var details = self.cards[key].querySelector('[data-collection-details]');
          if (details) details.hidden = true;
        });
      })
      .catch(function (error) {
        var target = self.form.querySelector('.prod__form-error');
        var message = (error && (error.description || error.message)) || 'Sorry, that could not be added to your basket.';
        if (target) target.textContent = message;
        console.warn('Product add-ons: add to cart failed.', error);
      })
      .then(function () {
        if (button) button.classList.remove('sf-spinner-loading');
      });
  };

  function init() {
    var nodes = document.querySelectorAll('[data-product-addons]');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].dataset.paddReady) continue;
      nodes[i].dataset.paddReady = 'true';
      new Addons(nodes[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
